import type { IShopRootState } from "@/shop/reducers/types";

/**
 * We previously used connected-react-router for this
 *
 * @deprecated Do not use this selector, use the react-router hooks instead
 * @param _
 * @returns
 */
export const getCurrentPath = (_: IShopRootState): string => location.hash.replace("#", "").split("?")[0]!;
